import React, { useState } from 'react';
import Sidebar from '../../components/navigation/Sidebar';

import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';
import MessageComposer from './components/MessageComposer';
import DeliveryTracking from './components/DeliveryTracking';
import PatientSegmentation from './components/PatientSegmentation';
import EngagementAnalytics from './components/EngagementAnalytics';

const PatientCommunicationHub = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [selectedView, setSelectedView] = useState('compose');
  const [selectedChannel, setSelectedChannel] = useState('all');

  const viewOptions = [
    { value: 'compose', label: 'Compose Message' },
    { value: 'tracking', label: 'Delivery Tracking' },
    { value: 'segmentation', label: 'Patient Segmentation' },
    { value: 'analytics', label: 'Engagement Analytics' }
  ];

  const channelOptions = [
    { value: 'all', label: 'All Channels' },
    { value: 'sms', label: 'SMS' },
    { value: 'email', label: 'Email' }
  ];

  const handleExportReport = () => {
    console.log('Exporting communication report...');
  };

  const handleRefreshData = () => {
    console.log('Refreshing communication data...');
  };

  const renderViewContent = () => {
    switch (selectedView) {
      case 'compose':
        return <MessageComposer />;
      case 'tracking':
        return <DeliveryTracking channel={selectedChannel} />;
      case 'segmentation':
        return <PatientSegmentation />;
      case 'analytics':
        return <EngagementAnalytics channel={selectedChannel} />;
      default:
        return <MessageComposer />;
    }
  };

  return (
    <div className="flex h-screen bg-background overflow-hidden pt-16">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-card border-b border-border px-4 md:px-6 py-4 flex-shrink-0">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground flex items-center gap-3">
                <Icon name="MessageSquare" size={28} className="text-primary" />
                Patient Communication Hub
              </h1>
              <p className="text-sm text-muted-foreground mt-1">
                Send treatment updates, appointment reminders, and care instructions via SMS and email
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                iconName="RefreshCw"
                iconPosition="left"
                onClick={handleRefreshData}
              >
                <span className="hidden sm:inline">Refresh</span>
              </Button>
              <Button
                variant="default"
                size="sm"
                iconName="Download"
                iconPosition="left"
                onClick={handleExportReport}
              >
                <span className="hidden sm:inline">Export Report</span>
              </Button>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="max-w-[1600px] mx-auto space-y-6">
            {/* View Selection and Filters */}
            <div className="bg-card rounded-xl border border-border shadow-elevation-2 p-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="flex-1 w-full sm:w-auto">
                  <Select
                    options={viewOptions}
                    value={selectedView}
                    onChange={setSelectedView}
                    placeholder="Select view"
                  />
                </div>
                {(selectedView === 'tracking' || selectedView === 'analytics') && (
                  <div className="w-full sm:w-64">
                    <Select
                      options={channelOptions}
                      value={selectedChannel}
                      onChange={setSelectedChannel}
                      placeholder="Filter by channel"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Dynamic Content Area */}
            {renderViewContent()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default PatientCommunicationHub;